import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from 'react-bootstrap/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Modal from 'react-bootstrap/Modal';

import BCStep3 from '../images/BC-Step-3.png';
import Switch from "react-switch";
import AlertConfirmModal from "./AlertConfirmModal";

const PaymentPreferenceBecomeCreator = ({
    user, step, page
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmPaypal, setShowConfirmPaypal] = useState(false);
    const [originalPaytype, setoriginalPaytype] = useState('');
    const [showConfirm, setShowConfirm] = useState(false);
    const [showConfirm2FACode, setShowConfirm2FACode] = useState(false);
    const [enable2FA, setEnable2FA] = useState(false);
    const [twoFactorCode, setTwoFactorCode] = useState('');
    const [error, setError] = useState('');
    const [resendCode, setResendCode] = useState(false);
    const [invalidCode, setInvalidCode] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [modalBody, setModalBody] = useState('');
    const [active2FA, setActive2FA] = useState(false);
    const [showResendCodeSuccessMessage, setShowResendCodeSuccessMessage] = useState(false);
    const [canEditEmail, setCanEditEmail] = useState(false);
    const [showEditEmailConfirmation, setShowEditEmailConfirmation] = useState(false);
    const [showPayoutForm, setShowPayoutForm] = useState(false);
    const [showPayoutError, setShowPayoutError] = useState(false);
    const [payoutError, setPayoutError] = useState('');
    const [showPayoutAlert, setShowPayoutAlert] = useState(false);
    const [showIsAustralianBasedAlert, setShowIsAustralianBasedAlert] = useState(false);

    useEffect(() => {
        if (user && Object.keys(user).length > 0) {
            fillForm(user);

            if (user.creator !== null) {
                setEnable2FA(user.creator.enabled_2fa);
                setActive2FA(user.creator.enabled_2fa);
                setCanEditEmail(!user.creator.enabled_2fa);
                formik.setFieldValue('pu_id', user.creator.pu_id);

                // based on creators table settings
                formik.setFieldValue('is_australian_based', user.creator.is_australian_based === true ? 'true' : 'false');
                formik.setFieldValue('reg_gst', user.creator.reg_gst === true ? 'true' : 'false');
            }
        }
    }, [user]);

    const openPayoutForm = (e) => {
        e.preventDefault();

        axios.get('api/pu-payouts/check-payout')
            .then((response) => {
                if (response.data.success) {
                    setShowPayoutForm(true);
                } else {
                    setPayoutError(response.data.message);
                    setShowPayoutError(true);
                }
            })
            .catch((error) => {
                console.log('error processing manual payout request');
            });
    };

    const closePayoutForm = () => {
        setShowPayoutForm(false);
        setShowPayoutError(false);
    };

    const handleCancelManualPayout = () => {
        setShowPayoutForm(false);
    };

    const handleClosePayoutCriteria = () => {
        setShowPayoutError(false);
    };

    const handleSubmitManualPayment = async () => {
        await axios.post('/api/pu-payouts/request-payout')
            .then((response) => {
                if (response.data.success) {
                    setShowPayoutForm(false);
                    setModalBody('Please complete the request form for early payout.');
                    setShowPayoutAlert(true);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onChangePayoutAmount = (value) => {
        // setPayoutAmount(value);
    };

    const formik = useFormik({
        initialValues: {
            is_australian_based: user.location && user.location.toLowerCase() == 'au' ? true : false,
            reg_gst: user.location && user.location.toLowerCase() == 'au' ? true : false,
            paytype: 0,
            paypal_email: '',
            paypal_email_confirmation: '',
            bsb_number: '',
            account_number: '',
            account_name: '',
            location: '',
            swiftcode: '',
            bank_account_type: 0,
            enabled_2fa: enable2FA,
            email: user.email,
            pu_id: '',
        },
        validationSchema: Yup.object({
            is_australian_based: Yup.boolean()
                .required('Please select at least one of the options'),
            reg_gst: Yup.boolean().when('is_australian_based', {
                is: true,
                then: Yup.boolean().required('Field is required'),
            }),
            paytype: Yup.number()
                .required('Please select a payment type'),
            paypal_email: Yup.string()
                .when('paytype', {
                    is: 1,
                    then: Yup.string()
                        .required('Paypal email is required')
                        .email('Paypal email must be a valid email address'),
                }),
            email: Yup.string()
                .when('enabled_2fa', {
                    is: (value) => value === true,
                    then: Yup.string()
                        .required('Email for 2FA verification is required')
                        .email('Email must be a valid email address'),
                }),
            paypal_email_confirmation: Yup.string().when('paypal_email', {
                is: (value) => value && value.length > 0,
                then: Yup.string()
                    .required(
                        'Paypal email address confirmation is required',
                    )
                    .oneOf([Yup.ref('paypal_email'), null], 'Must match paypal email'),
            }),
            bsb_number: Yup.string()
                .when(['paytype', 'bank_account_type'], {
                    is: (paytype, bank_account_type) => paytype == 2 && bank_account_type == 0,
                    then: Yup.string()
                        .matches(/^[a-z0-9]+$/i, 'Only Letters and numbers are allowed')
                        .required('BSB number is required')
                }),
            swiftcode: Yup.string()
                .when(['paytype', 'bank_account_type'], {
                    is: (paytype, bank_account_type) => paytype == 2 && bank_account_type == 1,
                    then: Yup.string()
                        .required('International Swift/BIC code is required')
                        .matches(/^[a-z0-9]+$/i, 'Only Letters and numbers are allowed')
                        .min(8, 'The Swift/BIC code must be 8 to 11 characters in length.  Please check with your bank.')
                        .max(11, 'The Swift/BIC code must be 8 to 11 characters in length.  Please check with your bank.')
                }),
            account_number: Yup.string()
                .when('paytype', {
                    is: 2,
                    then: Yup.string()
                        .required('Account number is required')
                        .matches(/^[0-9]+$/, 'Only numbers are allowed'),
                }),
            account_name: Yup.string()
                .when('paytype', {
                    is: 2,
                    then: Yup.string()
                        .required('Account name is required'),
                }),
            bank_account_type: Yup.number()
                .required('Bank account type is required')
        }),
        onSubmit: async (values, { setErrors }) => {
            setIsLoading(true);
            await axios.patch(`/api/update-payment-preference`, { ...values })
                .then((response) => {

                    if (!response.data.success) {
                        setModalBody('Sorry, cannot process your request right now. Try again later.');
                        setShowAlert(true);
                    } else {
                        if (!response.data.required_2fa) {
                            setModalBody('The payout preferences have been updated successfully.');
                            setShowAlert(true);
                            setShowConfirmPaypal(false);
                        } else {
                            setShowConfirm2FACode(true);
                        }
                    }
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        Object.keys(error.response.data.errors).forEach((key) => {
                            setErrors({
                                [key]: error.response.data.errors[key][0],
                            });
                        });
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
    });

    useEffect(() => {
        if (formik.values.paypal_email !== formik.values.paypal_email_confirmation) {
            setShowConfirmPaypal(true);
        }
    }, [formik]);



    const fillForm = (userInformation) => {
        if (userInformation.creator && Object.keys(userInformation.creator).length > 0) {
            Object.keys(formik.values).forEach((key) => {
                if (userInformation.creator[key] != null && key != 'is_australian_based') {
                    formik.setFieldValue(key, userInformation.creator[key].toString(), false);
                    if (key === 'paypal_email') {
                        formik.setFieldValue('paypal_email_confirmation', userInformation.creator[key], false);
                    }
                }

                if (key == 'paytype') {
                    setoriginalPaytype(userInformation.creator[key]);
                }

                if (key === 'location') {
                    // form sets value as string so set it as string
                    formik.setFieldValue('is_australian_based', userInformation.location == 'AU' ? 'true' : 'false', false);
                }

                if (key === 'email') {
                    formik.setFieldValue('email', userInformation.email);
                }
            });
        }
    };

    const handleSave = (e) => {
        e.preventDefault();

        if (originalPaytype != formik.values.paytype && formik.values.paytype == 0) {
            setShowConfirm(true);
            return;
        }

        formik.submitForm();
    };

    const handleRemove = (e) => {
        e.preventDefault();
        if (showConfirm) {
            formik.submitForm();
            setShowConfirm(false);
        }
    };

    const onChangeTwoFactorCode = (e) => {
        setError('');
        setInvalidCode(false);
        setResendCode(false);
        setTwoFactorCode(e.target.value);
        setShowResendCodeSuccessMessage(false);
    };

    const handleSubmit2FACode = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const formData = new FormData();
        formData.append('two_fa_code', twoFactorCode);
        formData.append('email', formik.values.email);
        formData.append('account_number', formik.values.account_number);
        formData.append('account_name', formik.values.account_name);
        formData.append('paytype', formik.values.paytype);
        formData.append('swiftcode', formik.values.swiftcode);
        formData.append('paypal_email', formik.values.paypal_email);
        formData.append('bsb_number', formik.values.bsb_number);
        formData.append('is_australian_based', formik.values.is_australian_based);
        formData.append('reg_gst', formik.values.reg_gst);
        formData.append('enabled_2fa', formik.values.enabled_2fa);
        formData.append('bank_account_type', formik.values.bank_account_type);

        axios({
            method: 'post',
            url: '/api/2fa-verification',
            data: formData,
        })
            .then((response) => {
                if (response.data.success) {
                    setModalBody('The payout preferences have been updated successfully.');
                    setShowAlert(true);
                    setShowConfirm2FACode(false);
                    setTwoFactorCode('');
                    setCanEditEmail(false);
                    setShowConfirmPaypal(false);

                    setEnable2FA(response.data.enabled_2fa);
                    setActive2FA(response.data.enabled_2fa);
                } else {
                    setEnable2FA(formik.values.enabled_2fa);
                    setActive2FA(formik.values.enabled_2fa);
                    setInvalidCode(true);
                }
            })
            .catch((error) => {
                console.log('2fa verification error', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handle2FA = (value) => {
        setEnable2FA(value);
        formik.setFieldValue('enabled_2fa', value);
        formik.setFieldValue('email', user.email);
    };

    const handleChangeEmail = (e) => {
        e.preventDefault();
        setModalBody(`The new email address will only be updated after the 2FA verification. The verified code will be sent to the current address ${user.email}.`);
        setShowEditEmailConfirmation(true);
    };

    const handleResendCode = (e) => {
        e.preventDefault();
        setShowResendCodeSuccessMessage(true);
        setInvalidCode(false);
        setResendCode(true);
        setTwoFactorCode('');
        setError(false);

        const formData = new FormData();
        formData.append('email', formik.values.email);

        axios({
            method: 'post',
            url: 'api/resend-2fa-code',
            data: formData,
        })
            .then((response) => {
                setResendCode(false);
                setInvalidCode(false);
                setShowAlert(false);
                setShowResendCodeSuccessMessage(true);
            })
            .catch((error) => {
                setIsLoading(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleCancel2FA = () => {
        setTwoFactorCode('');
        setShowConfirm2FACode(false);
        setEnable2FA(formik.values.enabled_2fa);
        formik.setFieldValue('enabled_2fa', enable2FA);
        setResendCode(false);
        setInvalidCode(false);
        setShowResendCodeSuccessMessage(false);
    };

    const handleCloseConfirmation = () => {
        setShowConfirmPaypal(false);
        setShowAlert(false);
    };

    const handleClosePaymentConfirmation = () => {
        setShowConfirmPaypal(false);
        setShowPayoutAlert(false);
        window.open('https://priva.uvdesk.com/en/', '_blank').location;
    };

    const handleEditEmailAlert = () => {
        console.log('agreed to edit email');
        setCanEditEmail(true);
        setShowEditEmailConfirmation(false);
    };

    const handleIsAustralianBased = (e) => {
        e.preventDefault();

        // set modal body
        setModalBody('Please confirm that you want to set your account to Non Australian person or business entity, as there will be no GST being collected for Taxation purposes.');

        // show alert
        setShowIsAustralianBasedAlert(true);
    };

    const confirmIsAustralianBasedChange = () => {
        formik.setFieldValue('is_australian_based', !formik.values.is_australian_based, true);
    };

    return (
        <div className="panel panel-default" id="payout-preference">
            <div className="panel-heading refpayout">
                <span className="BC-head-ico">
                    <LazyLoadImage src={BCStep3} />
                </span>
                <span>
                    {step ? `Step ${step} - Payout Preference` : 'Payout Preference'}
                    {active2FA ? ' - 2FA Enabled' : ''}
                </span>
            </div>
            <div className="panel-body">
                <form onSubmit={formik.handleSubmit} className="cmxform" id="subscription_payment_form" name="subscription_payment_form" method="post" action="" encType="multipart/form-data" noValidate="novalidate">
                    <div className="cur-meth">
                        <h6>
                            <b>Current payout method:</b>
                            {
                                [1, '1'].indexOf(formik.values.paytype) > 0 && (
                                    <span>
                                        <b className="paypaltext">Paypal</b>
                                        {' '}
                                        <a href={`mailto:${formik.values.paypal_email}`}>{formik.values.paypal_email}</a>
                                    </span>
                                )
                            }
                            {
                                [0, '0', ''].indexOf(formik.values.paytype) > 0 && <span><b className="paypaltext">None</b></span>
                            }
                            {
                                [2, '2'].indexOf(formik.values.paytype) > 0 && <span><b className="paypaltext">
                                    {
                                        formik.values.bank_account_type == '0'
                                            ? 'Australian Bank Account'
                                            : 'International SWIFT/BIC Code'
                                    }
                                </b></span>
                            }
                        </h6>
                    </div>
                    <div style={{ paddingBottom: '15px' }}>
                        <div className="two-fa-section">
                            <div className="switch-container" style={{ display: 'flex' }}>
                                <label className="switch">
                                    <Switch
                                        onChange={handle2FA}
                                        checked={enable2FA}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        value={enable2FA}
                                        height={20}
                                        width={35}
                                        onColor="#0097fe"
                                    />
                                </label>
                                <h6>
                                    <b>Two Factor Authentication</b>
                                </h6>
                            </div>
                        </div>
                        {
                            enable2FA && <div className={"email-container"}>
                                <span style={{ width: '70%' }}>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder=""
                                        autoComplete="off"
                                        className={`form-control ${formik.errors.email && formik.touched.email ? ' is-invalid' : ''}`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.email}
                                        disabled={active2FA && !canEditEmail}
                                    />
                                </span>
                                {
                                    (active2FA && !canEditEmail) && <span className="edit-email-container" style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '5px' }}>
                                        <a className="edit-email" onClick={(e) => handleChangeEmail(e)}>
                                            Edit
                                        </a>
                                    </span>
                                }
                            </div>
                        }
                    </div>

                    <div className="whr-based">
                        <h6>
                            <b>Where are you based?</b>
                            <span className="required">*</span>
                        </h6>
                        <div className="radio-input-rw">
                            <label>
                                <input
                                    type="radio"
                                    name="is_australian_based"
                                    id="non-australian"
                                    className={`${formik.errors.is_australian_based && formik.touched.is_australian_based ? ' is-invalid' : ''}`}
                                    onChange={handleIsAustralianBased}
                                    checked={formik.values.is_australian_based === 'false' || formik.values.is_australian_based === false}
                                    value="false"
                                />
                                <span>I am a non-Australian person or business entity (International)</span>
                            </label>
                        </div>

                        <div className="radio-input-rw">
                            <label>
                                <input
                                    type="radio"
                                    name="is_australian_based"
                                    id="australian"
                                    className={`${formik.errors.is_australian_based && formik.touched.is_australian_based ? ' is-invalid' : ''}`}
                                    onChange={formik.handleChange}
                                    value="true"
                                    checked={formik.values.is_australian_based === 'true' || formik.values.is_australian_based === true}
                                />
                                <span>I am an Australian person or business entity (Australia)</span>
                            </label>
                        </div>
                        {formik.errors.is_australian_based && formik.touched.is_australian_based ? <div className="invalid-feedback">{formik.errors.is_australian_based}</div> : null}
                    </div>

                    {
                        (formik.values.is_australian_based == 'true') && (
                            <div className="regst-gst" id="regst-gst">
                                <h6>
                                    <b>Are you registered for GST?</b>
                                    <span className="required">*</span>
                                </h6>
                                <div className="radio-input-rw">
                                    <label>
                                        <input
                                            type="radio"
                                            name="reg_gst"
                                            id="reg_gst-1"
                                            className={`${formik.errors.reg_gst && formik.touched.reg_gst ? ' is-invalid' : ''}`}
                                            onChange={formik.handleChange}
                                            value="true"
                                            checked={formik.values.reg_gst == 'true' || formik.values.reg_gst == true}
                                        />
                                        <span>Yes</span>
                                    </label>
                                </div>
                                <div className="radio-input-rw">
                                    <label>
                                        <input
                                            type="radio"
                                            name="reg_gst"
                                            id="reg_gst-2"
                                            className={`${formik.errors.reg_gst && formik.touched.reg_gst ? ' is-invalid' : ''}`}
                                            onChange={formik.handleChange}
                                            value="false"
                                            checked={[0, '0', '', 'false', false].indexOf(formik.values.reg_gst) > 0}
                                        />
                                        <span>No</span>
                                    </label>
                                </div>
                                {formik.errors.reg_gst && formik.touched.reg_gst ? <div className="invalid-feedback">{formik.errors.reg_gst}</div> : null}
                                <p><b><a target="_blank" href="https://priva.uvdesk.com/en/" rel="noreferrer">Learn More</a></b></p>
                            </div>
                        )
                    }
                    <div className="get-paid">
                        <h6>
                            <b>How would you like to get paid?</b>
                            <span className="required">*</span>
                        </h6>
                        <div className="radio-input-rw">
                            <label>
                                <input
                                    type="radio"
                                    name="paytype"
                                    id="paytype"
                                    className={`${formik.errors.paytype && formik.touched.paytype ? ' is-invalid' : ''}`}
                                    onChange={formik.handleChange}
                                    value="0"
                                    checked={formik.values.paytype == '0' || formik.values.paytype == 0}
                                />
                                <div>
                                    <span><b>None</b></span>
                                    <p>Funds will be held in a Privaposts holding account until you add a new payout method. Saving this option also removes the current payout method.</p>
                                </div>
                            </label>
                        </div>
                        <div className="radio-input-rw">
                            <label>
                                <input
                                    type="radio"
                                    name="paytype"
                                    id="paytype"
                                    className={`${formik.errors.paytype && formik.touched.paytype ? ' is-invalid' : ''}`}
                                    onChange={formik.handleChange}
                                    value="1"
                                    checked={formik.values.paytype == '1' || formik.values.paytype == 1}
                                />
                                <div>
                                    <span><b>PayPal</b></span>
                                    <p>
                                        {
                                            formik.values.is_australian_based == 'true'
                                                ? <>Transfer fee is $1.25 AUD.</>
                                                : <>Transfer fee is 2% of the amount transferred. Fee is capped at <b id="transferprice" className="d-inline">50</b> USD.</>
                                        }
                                    </p>
                                    <a target="_blank" href="https://priva.uvdesk.com/en/" rel="noreferrer">Learn More</a>
                                </div>
                            </label>
                        </div>
                        {
                            formik.values.paytype == '1' && (
                                <div className="paypal_email" id="paypal-email">
                                    <div className="paypal_email">
                                        <div className="form-group">
                                            <label htmlFor="paypal_email">Paypal Email</label>
                                            <input
                                                type="email"
                                                id="paypal_email"
                                                name="paypal_email"
                                                placeholder=""
                                                autoComplete="off"
                                                className={`form-control col-md-4${formik.errors.paypal_email && formik.touched.paypal_email ? ' is-invalid' : ''}`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.paypal_email}
                                            />
                                            {formik.errors.paypal_email && formik.touched.paypal_email ? <div className="invalid-feedback">{formik.errors.paypal_email}</div> : null}
                                        </div>
                                    </div>

                                    {showConfirmPaypal &&
                                        <div className="paypal_email mb-4" id="cng_email_div">
                                            <div className="form-group">
                                                <label htmlFor="paypal_email">Confirm PayPal Email</label>
                                                <input
                                                    type="text"
                                                    id="paypal_email_confirmation"
                                                    name="paypal_email_confirmation"
                                                    autoComplete="off"
                                                    className={`form-control col-md-4 ${formik.errors.paypal_email_confirmation && formik.touched.paypal_email_confirmation ? ' is-invalid' : ''}`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.paypal_email_confirmation}
                                                />
                                                {formik.errors.paypal_email_confirmation && formik.touched.paypal_email_confirmation ? <div className="invalid-feedback">{formik.errors.paypal_email_confirmation}</div> : null}
                                            </div>
                                        </div>
                                    }
                                </div>
                            )
                        }

                        <div className="radio-input-rw" id="au_bank_choice">
                            <label>
                                <input
                                    type="radio"
                                    name="paytype"
                                    id="paytype"
                                    className={`${formik.errors.paytype && formik.touched.paytype ? ' is-invalid' : ''}`}
                                    onChange={formik.handleChange}
                                    value="2"
                                    checked={formik.values.paytype === '2' || formik.values.paytype === 2}
                                />
                                <div>
                                    <span>Bank Account</span>
                                </div>
                            </label>
                        </div>
                        {
                            (formik.values.paytype === '2' || formik.values.paytype === 2) && <div className="whr-based" style={{ paddingLeft: '25px' }}>
                                <div className="radio-input-rw">
                                    <label>
                                        <input
                                            type="radio"
                                            name="bank_account_type"
                                            id="non-australian-bank"
                                            className={`${formik.errors.bank_account_type && formik.touched.bank_account_type ? ' is-invalid' : ''}`}
                                            onChange={formik.handleChange}
                                            checked={formik.values.bank_account_type === '1'}
                                            value="1"
                                        />
                                        <span>Non Australian (International) bank account</span>
                                    </label>
                                </div>

                                <div className="radio-input-rw">
                                    <label>
                                        <input
                                            type="radio"
                                            name="bank_account_type"
                                            id="australian-bank"
                                            className={`${formik.errors.bank_account_type && formik.touched.bank_account_type ? ' is-invalid' : ''}`}
                                            onChange={formik.handleChange}
                                            value="0"
                                            checked={formik.values.bank_account_type === '0'}
                                        />
                                        <span>Australian bank account</span>
                                    </label>
                                </div>
                                {formik.errors.bank_account_type && formik.touched.bank_account_type ? <div className="invalid-feedback">{formik.errors.bank_account_type}</div> : null}

                                <div className="mt-2">
                                    {formik.values.bank_account_type == 0 && <p><strong>Australian Bank Account</strong><br />Receive payments directly into your Australian bank account via your BSB and Account number and name.</p>}
                                    {formik.values.bank_account_type == 1 && <p><strong>International SWIFT/BIC Code</strong><br />Receive payments directly into your bank account via your SWIFT/BIC code and Account number and name.</p>}
                                </div>

                                <div className="bank-account mt-2 row" id="bank-account">
                                    <div className="col-md-12">
                                        <div className="row">
                                            {
                                                formik.values.bank_account_type == 0
                                                    ?
                                                    <div className="col-md-6 bank-account-field">
                                                        <label>BSB Number</label>
                                                        <input
                                                            type="text"
                                                            name="bsb_number"
                                                            id="bsb_number"
                                                            className={`form-control${formik.errors.bsb_number && formik.touched.bsb_number ? ' is-invalid' : ''}`}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            onPaste={(e) => e.preventDefault()}
                                                            value={formik.values.bsb_number}
                                                            pattern="[A-Za-z0-9]+"
                                                            style={
                                                                formik.errors.bsb_number && formik.touched.bsb_number ? { paddingRight: '30px' } : {}
                                                            }
                                                        />
                                                        {formik.errors.bsb_number && formik.touched.bsb_number ? <div className="invalid-feedback">{formik.errors.bsb_number}</div> : null}
                                                    </div>
                                                    : <div className="col-md-6 bank-account-field">
                                                        <label>SWIFT/BIC Code</label>
                                                        <input
                                                            type="text"
                                                            name="swiftcode"
                                                            id="swiftcode"
                                                            className={`form-control${formik.errors.swiftcode && formik.touched.swiftcode ? ' is-invalid' : ''}`}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.swiftcode}
                                                            style={
                                                                formik.errors.swiftcode && formik.touched.swiftcode ? { paddingRight: '26px' } : {}
                                                            }
                                                            pattern="[A-Za-z0-9]+"
                                                        />
                                                        {formik.errors.swiftcode && formik.touched.swiftcode ? <div className="invalid-feedback">{formik.errors.swiftcode}</div> : null}
                                                    </div>
                                            }
                                            <div className="col-md-6 bank-account-field">
                                                <label>Account Number</label>
                                                <input
                                                    type="text"
                                                    name="account_number"
                                                    id="account_number"
                                                    className={`form-control${formik.errors.account_number && formik.touched.account_number ? ' is-invalid' : ''}`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.account_number}
                                                />
                                                {formik.errors.account_number && formik.touched.account_number ? <div className="invalid-feedback">{formik.errors.account_number}</div> : null}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 bank-account-field">
                                                <label>Account Name</label>
                                                <input
                                                    type="text"
                                                    name="account_name"
                                                    id="account_name"
                                                    className={`form-control${formik.errors.account_name && formik.touched.account_name ? ' is-invalid' : ''}`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.account_name}
                                                />
                                                {formik.errors.account_name && formik.touched.account_name ? <div className="invalid-feedback">{formik.errors.account_name}</div> : null}
                                            </div>
                                        </div>

                                        <p className="mt-2" style={{ fontSize: '14px' }}>
                                            Note: Do not use Swift/BIC codes for Australian bank accounts. Please use BSB & Account number.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }

                        {formik.errors.paytype && formik.touched.paytype ? <div className="invalid-feedback">{formik.errors.paytype}</div> : null}
                    </div>
                    <div className="pay-pal-submit">
                        <Button
                            type="button"
                            disabled={isLoading}
                            className="btn theme-btn theme-btn-bordered"
                            onClick={handleSave}
                        >
                            {isLoading ? 'Processing' : 'Submit'}
                        </Button>
                    </div>

                    {page !== 'my-referrals' &&
                        <div className="pay-out-info">
                            <h6><b>Monthly Automatic Payout</b></h6>
                            <ul className="lsit-unstyled fa-ul">
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>Payouts to creators and referrers are automatically processed at the end of each month on the first business day after the month ends. Your funds will take approx 7 to 10 business days to hit your account (Business days do not include weekends or public holidays).</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>If you do not reach the minimum payout ($200.00), your earnings will rollover to the next monthly payout.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>Please make sure you enter your correct account details (whether it be PayPal email or Bank Account details). We will not provide compensation for money sent to the wrong account.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>
                                        <p style={{ lineHeight: '1.2', fontSize: '14px' }}>Your first payout may take a couple weeks longer to hit your account as your payout goes through extra security verification steps with our payment providers. We have no control over this.</p>
                                        <p style={{ lineHeight: '1.2', fontSize: '14px' }}>Please refer to our <a href={'/terms'}>Terms</a> for more info.</p>
                                    </span>
                                </li>
                            </ul>
                            <h6><b>Withdraw My Funds Manually</b></h6>
                            <ul className="lsit-unstyled fa-ul">
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>
                                        If you would like to receive your current balance before the end of the month please<span onClick={openPayoutForm} style={{ color: '#3490dc', fontWeight: '500', cursor: 'pointer' }}>click here</span>
                                    </span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>Minimum amount for manual withdrawals is $200USD.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>Please allow 7 - 10 business days to receive the funds.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>You have to wait until your current payout request hits your account before you can request your next payout i.e. You cannot request more than one manual payout per 7 business days.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>You cannot make a request within 7 business days before the end of the month as it clashes with the automatic end of month payout and will just be included with your end of month payout.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>Pending your account is verified and complies with the manual payout requirements your payout will be processed automatically on the first business day after your request has been submitted, no reply is required.</span>
                                </li>
                            </ul>
                            {page !== 'add-account' &&
                                <>
                                    <h6><b>Payout Disclaimer Regarding Exchange rates</b></h6>
                                    <ul className="lsit-unstyled fa-ul">
                                        <li>
                                            <span className="transparent-icon"><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                            <span>Never 'Google' your pay amount. This will never be correct for the following reasons:</span>
                                        </li>
                                        <li>
                                            <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                            <span>Your payout is the sum of all payments from your subscribers at the exchange rate at the time each payment is received.</span>
                                        </li>
                                        <li>
                                            <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                            <span>Exchange rates change every second of every day, so every payment made by your followers will be at a different exchange rate.</span>
                                        </li>
                                        <li>
                                            <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                            <span>Financial institutions who convert the currency such as banks, PayPal and payment providers always add a mark-up to the exchange rate in order to cover their costs to convert the currency. We have no control over the conversion of currency. As a result, the exchange rate you 'Google' is impossible to achieve.</span>
                                        </li>
                                        <li>
                                            <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                            <span>This also means if you 'Google' the exchange on one day it’ll be different to the next.</span>
                                        </li>
                                        <li>
                                            <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                            <span>
                                                For more information
                                                {' '}
                                                <a href="https://priva.uvdesk.com/en/" target="_blank" rel="noreferrer">click here</a>
                                            </span>
                                        </li>
                                    </ul>
                                </>
                            }
                        </div>
                    }
                    {page === 'my-referrals' &&
                        <div className="pay-out-info">
                            <h6><b>Payout Information</b></h6>
                            <ul className="lsit-unstyled fa-ul">
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>Payouts to creators and referrers are automatically made in the first week of each month.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>If you do not reach the minimum payout ($200.00), your earnings will rollover to the next monthly payout.</span>
                                </li>
                                <li>
                                    <span><FontAwesomeIcon icon={['fas', 'circle']} /></span>
                                    <span>For payouts via Paypal, please make sure you enter your correct email. We will not provide compensation for money sent to the wrong account.</span>
                                </li>
                            </ul>
                        </div>
                    }
                </form>
            </div>

            <Modal size="md" className="alert-confirm-modal modal-size-custom" centered show={showConfirm} onHide={() => setShowConfirm(false)}>
                <Modal.Header style={{ borderBottom: 0 }} closeButton>
                    <Modal.Title>
                        <strong>Manage Payout Method</strong>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-secondary">Are you sure you want to remove the current payout method?</p>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: 0 }}>
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <div className="alertconfirm-btns">
                            <button
                                type="button"
                                onClick={() => setShowConfirm(false)}
                                style={{ width: '100px' }}
                                className="btn btn-secondary">
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleRemove}
                                style={{ width: '100px' }}
                                className="btn btn-primary">
                                Remove
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>


            {
                !showAlert && <Modal size="md" className="alert-confirm-modal modal-size-custom" centered show={showConfirm2FACode}
                    onHide={handleCancel2FA}>
                    <Modal.Header style={{ borderBottom: 0 }} closeButton>
                        <Modal.Title>
                            <strong>Two Factor Authentication Verification</strong>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ textAlign: 'left', padding: '10px 20px' }}>
                        <p>A verification code has been send to your current email address {user.email}.</p>
                        <p>If you have not received the email after some time, please check your email spam and junk email folder.</p>
                        <div className={'two-fa-form'}>
                            <div className="two-fa-code-container">
                                <span>2FA Code:</span>
                                <input
                                    style={{ width: '50%' }}
                                    type="number"
                                    value={twoFactorCode}
                                    onChange={onChangeTwoFactorCode}
                                    className={`rounded ${invalidCode != '' ? 'form-control is-invalid' : ''}`}
                                />
                            </div>
                            {
                                !showResendCodeSuccessMessage && <span className="resend-code-container" style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '5px' }}>
                                    <a className="resend-code" onClick={(e) => handleResendCode(e)}>
                                        Resend Code
                                    </a>
                                </span>
                            }
                        </div>
                        {error && <span className="help-text text-danger">{error}</span>}
                        {
                            !error && showResendCodeSuccessMessage && <span className={'text-success'}>2FA code has been resent.</span>
                        }
                        {
                            (invalidCode || error) && <span className={'text-danger'}>
                                Invalid 2FA code. Use the most recent email with the 2FA code, in case you have resent multiple codes that may have been delay to receive the latest code.
                            </span>
                        }
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: '0px', justifyContent: 'center' }}>
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className="alertconfirm-btns two-fa-confirmation-btns">
                                <button
                                    type="button"
                                    onClick={handleCancel2FA}
                                    style={{ width: '100px' }}
                                    className="btn btn-secondary">
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={handleSubmit2FACode}
                                    style={{ width: '100px' }}
                                    className="btn btn-primary">
                                    Verify
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            }

            {showAlert && <AlertConfirmModal show={showAlert} setShow={handleCloseConfirmation} modalBody={modalBody} />}
            {showPayoutAlert && <AlertConfirmModal show={showPayoutAlert} setShow={handleClosePaymentConfirmation} modalBody={modalBody} />}

            {showEditEmailConfirmation && <AlertConfirmModal show={showEditEmailConfirmation} setShow={handleEditEmailAlert} modalBody={modalBody} />}

            {
                showIsAustralianBasedAlert && <AlertConfirmModal
                    show={showIsAustralianBasedAlert}
                    setShow={setShowIsAustralianBasedAlert}
                    modalBody={modalBody}
                    useFunction={confirmIsAustralianBasedChange}
                    isConfirm
                />
            }

            {
                showPayoutError && <Modal show={showPayoutError} centered onHide={closePayoutForm}>
                    <Modal.Body>
                        {
                            (payoutError !== "") ? <p className={'text-center'}>{payoutError}</p> :
                                <>
                                    <p>
                                        Your request has not met the requirement for a manual payout at this time:
                                    </p>
                                    <p>Payout criteria:</p>
                                    <ul>
                                        <li>MyFunds must be above $200USD</li>
                                        <li>Manual payouts cannot be made 7 days before the end of the month</li>
                                        <li>Manual payouts are unavailable if it is your first month earning / first payout</li>
                                        <li>ID must be verified</li>
                                    </ul>
                                </>
                        }
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: 'unset', justifyContent: 'center' }}>
                        <button
                            type="button"
                            onClick={handleClosePayoutCriteria}
                            style={{ width: '100px' }}
                            className={"btn btn-primary"}>
                            OK
                        </button>
                    </Modal.Footer>
                </Modal>
            }

            {
                showPayoutForm && <Modal
                    show={showPayoutForm}
                    onHide={closePayoutForm}
                    centered
                >
                    <Modal.Header className={'manual-payout-form-header'}>
                        <Modal.Title style={{ textAlign: 'center' }}>
                            <strong>Manual Payout Request</strong>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className={'manual-payout-form-body'} style={{ textAlign: 'center' }}>
                        <p>Please allow 7 - 10 business days to receive the payout.</p>
                        <p>To proceed please submit this request.</p>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: '0px', justifyContent: 'center' }}>
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className="alertconfirm-btns manual-payout-btns">
                                <button
                                    type="button"
                                    onClick={handleCancelManualPayout}
                                    style={{ width: '100px' }}
                                    className={"btn btn-secondary"}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={handleSubmitManualPayment}
                                    style={{ width: '100px' }}
                                    className={"btn btn-primary"}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    );
};

export default PaymentPreferenceBecomeCreator;
